const getQuizdata = async (formId: string, shopId: string) => {
    const response = await fetch(`https://service.tangent.ai/shopify/get-config?shop_id=${shopId}&form_id=${formId}`, {
        method: "get",
        headers: {
            'Authorization': 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJodHRwczovL3NlbGYtc2VydmUtYXBwLXN0b3JlLm15c2hvcGlmeS5jb20vYWRtaW4iLCJkZXN0IjoiaHR0cHM6Ly9zZWxmLXNlcnZlLWFwcC1zdG9yZS5teXNob3BpZnkuY29tIiwiYXVkIjoiZDgxYWFiOTU5MzEwMTZkNmE5N2U0Mzg1NjJkZjk1NDIiLCJzdWIiOiI2OTI4NjE2NjcwNyIsImV4cCI6MjY3MDMzNDg2OCwibmJmIjoxNjcwMzM0ODA4LCJpYXQiOjE2NzAzMzQ4MDgsImp0aSI6IjY1NWJhMGQ3LTk0NmYtNGIyNy1iYTczLTlmNzc5MTk4MmU0NSIsInNpZCI6IjNkY2RjNGRiNDg3OGY0NWUxNmFjNzUwMTQ0Y2VkMmEwZDBmNDdlZjQwMTlkYTIwM2FmOTkzMjEwOTA3NWYxYzAifQ.V4iOtoGhfkTpBLx4579RDtbfSNahEHHU8GqJC8F5U8s'
        }
    });
    const data = await response.json();
    if (data.quiz) {
        return data
    } else {
        throw new Error("No quiz data found");
    }
};

export default getQuizdata;